<div class="dialog-wrapper">
  <div class="row mb-2">
    <div class="col-sm-10">
      <mat-label class="dialog-title">Lookup Records</mat-label>
    </div>
    <div class="col-sm-2">
      <mat-icon (click)="onClose()">close</mat-icon>
    </div>
  </div>

  <!-- Source is automatically set based on which table opened the dialog -->
  <!-- <div class="row mb-3">
    <div class="col-sm-12">
      <mat-label class="section-label">Source</mat-label>
      <mat-radio-group [formControl]="sourceControl" class="radio-group">
        <mat-radio-button [value]="EquipmentSource.E1">E1</mat-radio-button>
        <mat-radio-button [value]="EquipmentSource.Predix">Predix</mat-radio-button>
      </mat-radio-group>
    </div>
  </div> -->

  <div class="row mb-3">
    <div class="col-sm-12">
      <mat-label class="section-label">Search by Tag Number</mat-label>
      <form class="search-container" [formGroup]="searchForm" (ngSubmit)="searchByTag()">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Tag Number</mat-label>
          <input matInput formControlName="tag" placeholder="Enter tag number">
        </mat-form-field>
        <button mat-raised-button color="primary" type="submit" [disabled]="isSearching()">
          @if (isSearching()) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Search
          }
        </button>
      </form>
    </div>
  </div>

  @if (showSearchResults()) {
    <div class="row mb-3 search-results">
      <div class="col-sm-12">
        <div class="results-header">
          <mat-label class="section-label">Search Results ({{ searchResults().length }})</mat-label>
          <button mat-icon-button (click)="clearSearch()" matTooltip="Clear search">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        @if (searchResults().length > 0) {
          <div class="results-list">
            @for (item of searchResults(); track item.id) {
              <div class="result-item">
                <mat-checkbox
                  [checked]="isSearchItemSelected(item)"
                  (change)="toggleSearchSelection(item, $event)"
                >
                  <div class="result-details">
                    <div class="result-tag">{{ item.tagNumber }}</div>
                    <div class="result-description">{{ item.description }}</div>
                    <div class="result-facility">{{ item.facility || 'N/A' }}</div>
                  </div>
                </mat-checkbox>
              </div>
            }
          </div>
        } @else {
          <div class="no-results">
            <mat-icon>search_off</mat-icon>
            <p>No equipment found</p>
          </div>
        }
      </div>
    </div>
  }

  <!-- <div class="row options">
    <div class="col-sm-12">
      <mat-label class="section-label">Or Browse Records</mat-label>
      <app-chips
        class="chips"
        label="Select record"
        [placeholder]="
          selected().length ? 'Add more records' : 'Look for records'
        "
        [value]="values()"
        [options]="equipmentOptions"
        (changed)="getSelectedEquipments($event)"
        (loadNext)="loadNext()"
      />

      @if (loading && !isSearching()) {
        <div class="spinner-wrapper">
          <mat-spinner class="spinner"></mat-spinner>
        </div>
      }
    </div>
  </div> -->

  <div class="row controls">
    <div class="col-sm-12">
      <button
        mat-raised-button
        color="primary"
        (click)="importSelected()"
        [disabled]="loading || searchSelection.selected.length === 0">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Import
        }
      </button>
      <button mat-button (click)="onClose()">Cancel</button>
    </div>
  </div>
</div>
